
define('text!templates/grid_footer.html',[],function () { return '{{#pageControls}}\n<div class="page-controls">\n    <div class="page-count">\n        <span>Showing <span data-bind="count">{{count}}</span> of <span data-bind="total_count">{{total}}</span></span>\n    </div>\n</div>\n{{/pageControls}}\n';});

